<app-material>
    <div class="header" header>
        <h2>{{ 'atom.tool-requests-lines.table.title' | translate }}</h2>
    </div>
    <ng-container body>
        <app-tool-requests-lines-table [toolRequests]="pendingToolRequests"
                                       [(statusFilters)]="filterStatusList"
                                       [tableConfig]="tableConfig"
                                       [isLoading]="isLoading"
                                       [hasTitle]="false"
                                       [isMaterial]="false"
                                       [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                                       (sortChange)="onSortChange($event)"
                                       (filterChange)="onFilter($event)"
                                       (processClick)="onProcess($event)"
                                       (resumeClick)="onResume($event)"
                                       (pageChange)="onPageChange($event)">
        </app-tool-requests-lines-table>
    </ng-container>
</app-material>



